import JiaMengHeader from '@components/JiaMeng/Header/Customer'
import { asyncLoad } from '@util'

const AsyncCustomerInfo = asyncLoad(() =>
  import('@components/LocalMerchant/CustomerInfo')
)

const AsyncDetail = asyncLoad(() =>
  import('@components/LocalMerchant/CustomerInfo/Detail')
)

export default {
  path: 'customerInfo',
  component: JiaMengHeader,
  indexRoute: {
    component: AsyncCustomerInfo
  },
  stat: '客资推荐/首页',
  childRoutes: [
    {
      path: 'detail/:id',
      component: AsyncDetail,
      stat: '客资推荐/推荐详情'
    }
  ]
}
